export default __webpack_public_path__ + "static/media/eth.ee7fc645.png";